import React, { useState, useEffect, useRef } from "react";
import {
  GoogleMap,
  Marker,
  Circle,
  useJsApiLoader,
} from "@react-google-maps/api";
import trailApi from "../api/trails";
import "react-modern-drawer/dist/index.css";
import {
  getTeamNumberSvg,
  MapRecenter,
  RoadMap,
  Satelite,
  FocusIcon,
  DrawIcon,
  TrashIcon,
  CrossIcon,
} from "../svgs/SVGs";
import LoginPage from "../components/Login";
import { Tooltip } from "@mui/material";
import Swal from "sweetalert2";
import {
  convertKeysToCamelCase,
  extractAndCapitalizePOIsInitial,
} from "../utility/UtilFunctions";
import MultiselectDropdown from "../components/MultiselectDropdown";
import TrimmableText from "../components/TrimmableText";

export default function DesignPOI() {
  const [accessToken, setAccessToken] = useState("");

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchAccessTokenFromCookie = () => {
      setAccessToken("asdasdsa");

      // //console.log("running");
      // const accesstoken = Cookies.get("accesstoken");
      // if (accesstoken) {
      //   setAccessToken(accesstoken);
      // } else {
      //   setAccessToken("");
      // }
    };

    fetchAccessTokenFromCookie();

    const interval = setInterval(fetchAccessTokenFromCookie, 2000);

    return () => clearInterval(interval);
  }, []);

  const mapRef = useRef(null);

  const mapContainerStyle = {
    width: "100%",
    height: "100%",
  };

  const ReCenterToEurope = () => {
    console.log("minLatLng", minLatLng);
    console.log("maxLatLng", maxLatLng);
    // Adjust map bounds
    if (mapRef.current) {
      if (
        maxLatLng.lat === 0 &&
        maxLatLng.lng === 0 &&
        minLatLng.lat === 0 &&
        minLatLng.lng === 0
      ) {
        const bounds = new window.google.maps.LatLngBounds(
          new window.google.maps.LatLng(35.0, -10.0),
          new window.google.maps.LatLng(71.0, 40.0)
        );
        mapRef.current.fitBounds(bounds);
        mapRef.current.setZoom(5);
      } else {
        const bounds = new window.google.maps.LatLngBounds(
          new window.google.maps.LatLng(minLatLng),
          new window.google.maps.LatLng(maxLatLng)
        );
        mapRef.current.fitBounds(bounds);
      }
    }
  };

  const [center, setCenter] = useState({
    lat: 37.7749,
    lng: -122.4194,
  });

  const [maxLatLng, setMaxLatLng] = useState({
    lat: 37.7749,
    lng: -122.4194,
  });

  const [minLatLng, setMinLatLng] = useState({
    lat: 37.7749,
    lng: -122.4194,
  });

  const changeMapType = () => {
    const currentMapType = mapRef.current.getMapTypeId();
    setMapType(currentMapType === "hybrid" ? "roadmap" : "hybrid");
    mapRef.current.setMapTypeId(
      currentMapType === "hybrid" ? "roadmap" : "hybrid"
    );
  };

  const [stageId, setStageId] = useState(0);
  const [stagePrefix, setStagePrefix] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const stageId = params.get("stageId");
    const stagePrefix = params.get("stagePrefix");
    if (stageId) {
      setStageId(stageId);
    }

    if (stagePrefix) {
      setStagePrefix(stagePrefix);
    }
  }, []);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyB3FTLMCjvinLhH622_HKI1WsfYuuKA-vE",
  });

  const [mapType, setMapType] = useState("roadmap");

  const onLoad = React.useCallback(function callback(map) {
    mapRef.current = map;
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    mapRef.current = null;
  }, []);

  const [pOIsMarkerPosition, setPOIsMarkerPosition] = useState(null);

  const SelectPOIsLocationOnMap = (event) => {
    setPOIsMarkerPosition((prev) => ({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
      poisName: prev?.poisName ?? "",
      radius: prev?.radius ?? 100,
      points: prev?.points ?? 100,
      speedLimit: prev?.speedLimit ?? 100,
      extraInfo: prev?.extraInfo ?? "",
    }));
  };

  const MaxZoomToPlottedPOIs = (lat, lng) => {
    console.log("i am called");

    if (lat && lng) {
      const target = new window.google.maps.LatLng(lat, lng);
      mapRef.current.panTo(target);
      mapRef.current.setZoom(16);
    } else if (pOIsMarkerPosition) {
      const target = new window.google.maps.LatLng(
        pOIsMarkerPosition.lat,
        pOIsMarkerPosition.lng
      );
      mapRef.current.panTo(target);
      mapRef.current.setZoom(16);
    }
  };

  // sweetalert toat
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  // save POIs API
  const SavePOI = async () => {
    console.log("while saving", pOIsMarkerPosition.poisName);
    const response = await trailApi.savePoi(
      pOIsMarkerPosition.poisName,
      pOIsMarkerPosition.radius,
      pOIsMarkerPosition.lat,
      pOIsMarkerPosition.lng,
      pOIsMarkerPosition.id,
      stageId
    );

    console.log("response", response);

    if (response?.data?.Success) {
      getPOIsListByStageId();
      Toast.fire({
        icon: "success",
        title: "POI added successfully!",
      });

      setPOIsMarkerPosition((prev) => ({
        lat: 0,
        lng: 0,
        poisName: "",
        radius: 100,
        points: 100,
        speedLimit: 100,
        extraInfo: "",
        id: 0,
      }));
      setSelectedPoisType(null);
      setSelectedJokerType(null);
      setActivePOIsEditId(0);
    } else {
      Toast.fire({
        icon: "error",
        title: response?.data?.Message ?? "Something went wrong!",
      });
    }
  };

  const [poisTypes, setPoisTypes] = useState([]);
  const [jokerTypes, setJokerTypes] = useState([]);
  const [savedPOIs, setSavedPOIs] = useState([]);
  const [selectedPoisType, setSelectedPoisType] = useState();
  const [selectedJokerType, setSelectedJokerType] = useState();

  // filter API
  const getFiltersData = async () => {
    try {
      const response = await trailApi.getfilters(0, 0, []);
      const filters = convertKeysToCamelCase(response.data.Filters);
      setPoisTypes(filters.poiTypes);
      setJokerTypes(filters.jokerTypes);
    } catch (er) {
      console.log(er);
    }
  };

  // filter API
  const getPOIsListByStageId = async () => {
    try {
      const response = await trailApi.getPOIsListByStageId(stageId);
      setSavedPOIs(response?.data?.POIsList);
      const centerLat = response.data.CenterLatitude;
      const centerLng = response.data.CenterLongitude;
      const minLat = response.data.MinLatitude;
      const minLng = response.data.MinLongitude;
      const maxLat = response.data.MaxLatitude;
      const maxLng = response.data.MaxLongitude;

      setCenter({ lat: centerLat, lng: centerLng });
      setMinLatLng({ lat: minLat, lng: minLng });
      setMaxLatLng({ lat: maxLat, lng: maxLng });

      if (mapRef.current) {
        setCenter({ lat: centerLat, lng: centerLng });
        setMinLatLng({ lat: minLat, lng: minLng });
        setMaxLatLng({ lat: maxLat, lng: maxLng });

        if (maxLat === 0 && maxLng === 0 && minLat === 0 && minLng === 0) {
          const bounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(35.0, -10.0),
            new window.google.maps.LatLng(71.0, 40.0)
          );
          mapRef.current.fitBounds(bounds);
          mapRef.current.setZoom(5);
        } else {
          const bounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(minLat, minLng),
            new window.google.maps.LatLng(maxLat, maxLng)
          );
          mapRef.current.fitBounds(bounds);
          if (response?.data?.POIsList?.length === 1) {
            mapRef.current.setZoom(13);
          }
        }
      }
    } catch (er) {
      console.log(er);
    }
  };

  // calling filter
  useEffect(() => {
    getFiltersData();
    setPOIsMarkerPosition({
      lat: 0,
      lng: 0,
      poisName: "",
      radius: 100,
      points: 100,
      speedLimit: 100,
      extraInfo: "",
      id: 0,
    });
  }, []);

  // calling getPOIsListByStageId API
  useEffect(() => {
    if (stageId && stageId > 0) {
      getPOIsListByStageId();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stageId]);

  // on change of POIs Type, deciding Points in +/-
  useEffect(() => {
    if (!selectedPoisType?.[0]) return;

    const key = selectedPoisType[0].key;
    const isMalusOrRoadblock = ["Malus", "Roadblock"].includes(key);

    setPOIsMarkerPosition((prev) => {
      const prevPoints = prev?.points ?? 0;
      const newPoints = isMalusOrRoadblock
        ? -Math.abs(prevPoints)
        : Math.abs(prevPoints);

      if (prevPoints === newPoints) return prev; // Prevent unnecessary updates

      return {
        ...prev,
        points: newPoints,
      };
    });
  }, [selectedPoisType]);

  // updating POIs name on every change
  useEffect(() => {
    const key = selectedPoisType?.[0]?.key;
    if (!key) return;

    let formattedName = `${stagePrefix} ${key} `;

    if (key === "Snelheid") {
      formattedName += `${pOIsMarkerPosition?.speedLimit ?? 0} km/h`;
    } else if (key === "Joker") {
      formattedName += selectedJokerType?.[0]?.keyInitial ?? "";
    } else if (!["Snelheid", "Finish", "Joker"].includes(key)) {
      formattedName += `${pOIsMarkerPosition?.points ?? 0} pnt`;
    }

    if (pOIsMarkerPosition?.extraInfo) {
      if (key === "Finish") {
        formattedName += `${pOIsMarkerPosition.extraInfo}`;
      } else {
        formattedName += ` ${pOIsMarkerPosition.extraInfo}`;
      }
    }

    setPOIsMarkerPosition((prev) => ({
      ...prev,
      poisName: formattedName,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedPoisType,
    selectedJokerType,
    pOIsMarkerPosition?.speedLimit,
    pOIsMarkerPosition?.points,
    pOIsMarkerPosition?.extraInfo,
  ]);

  // focusing marker on the screen center
  useEffect(() => {
    if (
      mapRef.current &&
      pOIsMarkerPosition &&
      !isNaN(pOIsMarkerPosition.lat) &&
      !isNaN(pOIsMarkerPosition.lng)
    ) {
      const lat = Number(pOIsMarkerPosition.lat);
      const lng = Number(pOIsMarkerPosition.lng);
      if (lat !== 0 && lng !== 0) {
        mapRef.current.panTo({ lat, lng });
      }
    }
  }, [pOIsMarkerPosition?.lat, pOIsMarkerPosition?.lng]);

  const deleteBtnHandler = (recordId) => {
    Swal.fire({
      title:
        "Are you sure you want to delete this POIs this cannot be reverted?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "my-popup",
        confirmButton: "my-confirm-btn",
        cancelButton: "my-cancel-btn",
      },
      allowEscapeKey: false,
      preConfirm: () => {
        return deleteRecord(recordId);
      },
    });
  };

  const deleteRecord = async (id) => {
    const response = await trailApi.deletePOI(id);
    if (response?.data?.Success) {
      getPOIsListByStageId();
      Toast.fire({
        icon: "success",
        title: "POI deleted successfully!",
      });
    } else {
      Toast.fire({
        icon: "error",
        title: "POI could not be deleted!",
      });
    }
  };

  const [activePOIsEditId, setActivePOIsEditId] = useState(0);

  const cancelBtnHandler = () => {
    setPOIsMarkerPosition((prev) => ({
      lat: 0,
      lng: 0,
      poisName: "",
      radius: 100,
      points: 100,
      speedLimit: 100,
      extraInfo: "",
      id: 0,
    }));
    setSelectedPoisType(null);
    setSelectedJokerType(null);
    setActivePOIsEditId(0);
  };

  const editBtnHandler = (poisObject) => {
    if (poisObject) {
      setActivePOIsEditId(poisObject.Id);
      const parsedName = poisObject.Name.replace(/\bpnt\b\s*/i, "")
        .replace(/\bkm\/h\b\s*/i, "")
        .trim();
      console.log("parsedName", poisObject.Name, parsedName);
      const parts = parsedName.split(" ");
      console.log("parts", parts);
      let poitns = 0;
      let speedLimit = 0;
      let extraInfo = "";
      if (poisObject.Name.includes("Finish")) {
        setSelectedPoisType([poisTypes.find((x) => x.key === "Finish")]);
        // extraInfo = parts[2];
        extraInfo =
          Array.isArray(parts) && parts.length > 2
            ? parts.slice(2).filter(Boolean).join(" ")
            : "";
      } else if (poisObject.Name.includes("Bonus")) {
        setSelectedPoisType([poisTypes.find((x) => x.key === "Bonus")]);
        poitns = parts[2];
        // extraInfo = parts[3];
        extraInfo =
          Array.isArray(parts) && parts.length > 3
            ? parts.slice(3).filter(Boolean).join(" ")
            : "";
      } else if (poisObject.Name.includes("Joker")) {
        setSelectedPoisType([poisTypes.find((x) => x.key === "Joker")]);
        const jokerTypeLetter = parts[2];
        // extraInfo = parts[3];
        extraInfo =
          Array.isArray(parts) && parts.length > 3
            ? parts.slice(3).filter(Boolean).join(" ")
            : "";
        console.log(
          "jokerTypeLetter",
          jokerTypeLetter,
          jokerTypes.find((x) => x.key === "ReduceMinute")
        );
        if (jokerTypeLetter === "M") {
          setSelectedJokerType([
            jokerTypes.find((x) => x.key === "ReduceMinute"),
          ]);
        } else if (jokerTypeLetter === "R") {
          setSelectedJokerType([
            jokerTypes.find((x) => x.key === "RemoveCarFromRadar"),
          ]);
        } else if (jokerTypeLetter === "D") {
          setSelectedJokerType([
            jokerTypes.find((x) => x.key === "ReduceDistance"),
          ]);
        } else if (jokerTypeLetter === "Z") {
          setSelectedJokerType([jokerTypes.find((x) => x.key === "TrailZoom")]);
        }
      } else if (poisObject.Name.includes("Malus")) {
        setSelectedPoisType([poisTypes.find((x) => x.key === "Malus")]);
        poitns = parts[2];
        // extraInfo = parts[3];
        extraInfo =
          Array.isArray(parts) && parts.length > 3
            ? parts.slice(3).filter(Boolean).join(" ")
            : "";
      } else if (poisObject.Name.includes("Snelheid")) {
        setSelectedPoisType([poisTypes.find((x) => x.key === "Snelheid")]);
        speedLimit = parts[2];
        // extraInfo = parts[3];
        extraInfo =
          Array.isArray(parts) && parts.length > 3
            ? parts.slice(3).filter(Boolean).join(" ")
            : "";
      } else if (poisObject.Name.includes("Roadblock")) {
        setSelectedPoisType([poisTypes.find((x) => x.key === "Roadblock")]);
        poitns = parts[2];
        // extraInfo = parts[3];
        extraInfo =
          Array.isArray(parts) && parts.length > 3
            ? parts.slice(3).filter(Boolean).join(" ")
            : "";
      }

      setPOIsMarkerPosition((prev) => ({
        lat: poisObject.Lat,
        lng: poisObject.Lng,
        poisName: poisObject.Name,
        radius: poisObject.Radius,
        points: poitns,
        speedLimit: speedLimit,
        extraInfo: extraInfo,
        id: poisObject.Id,
      }));
    }
  };

  useEffect(() => {
    console.log("activePOIsEditId", activePOIsEditId);
  }, [activePOIsEditId]);

  return (
    <>
      {accessToken ? (
        <>
          {isLoaded ? (
            <div className="position-relative">
              {/* Main Content Div */}
              <div className="p-0 bg-light" style={{ height: "100vh" }}>
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={center}
                  zoom={12}
                  onLoad={onLoad}
                  onUnmount={onUnmount}
                  options={{
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false,
                    draggableCursor: "pointer",
                    draggingCursor: "grab",
                    gestureHandling: "greedy", // 👈 allow scroll to zoom
                  }}
                  onClick={SelectPOIsLocationOnMap}
                >
                  {/* Map POIs Manual Plotting */}
                  {pOIsMarkerPosition &&
                    pOIsMarkerPosition.lat !== 0 &&
                    pOIsMarkerPosition.lng !== 0 && (
                      <>
                        <Marker
                          position={pOIsMarkerPosition}
                          icon={getTeamNumberSvg(
                            extractAndCapitalizePOIsInitial(
                              pOIsMarkerPosition.poisName
                            ),
                            "#800000"
                          )}
                          draggable={true}
                          onDragEnd={(e) =>
                            setPOIsMarkerPosition((prev) => ({
                              ...prev,
                              lat: e.latLng.lat(),
                              lng: e.latLng.lng(),
                            }))
                          }
                        />
                        <Circle
                          center={{
                            lat: pOIsMarkerPosition.lat,
                            lng: pOIsMarkerPosition.lng,
                          }}
                          radius={pOIsMarkerPosition.radius}
                          options={{
                            color: "red",
                            fillColor: "red",
                            fillOpacity: 0.1,
                            strokeColor: "red",
                            strokeOpacity: 0.5,
                            strokeWeight: 2,
                          }}
                        />
                      </>
                    )}

                  {/* circles */}
                  {savedPOIs &&
                    savedPOIs
                      .filter((x) => x.Id !== activePOIsEditId)
                      .map((savedPOI, index) => (
                        <React.Fragment key={index}>
                          <Marker
                            position={{ lat: savedPOI.Lat, lng: savedPOI.Lng }}
                            icon={getTeamNumberSvg(
                              extractAndCapitalizePOIsInitial(savedPOI.Name),
                              "#800000"
                            )}
                          />
                          <Circle
                            center={{ lat: savedPOI.Lat, lng: savedPOI.Lng }}
                            radius={savedPOI.Radius}
                            options={{
                              fillColor: "red",
                              fillOpacity: 0.1,
                              strokeColor: "red",
                              strokeOpacity: 0.5,
                              strokeWeight: 2,
                            }}
                          />
                        </React.Fragment>
                      ))}
                </GoogleMap>
              </div>

              {/* menu icons div */}
              <div className="position-absolute top-0 start-0 bg-none p-3 d-block">
                <Tooltip title="Change Map Type">
                  <button
                    type="button"
                    style={{
                      borderRadius: "50%",
                      width: "45px",
                      height: "45px",
                      marginLeft: "5px",
                      backgroundColor: "#fff",
                    }}
                    onClick={changeMapType}
                  >
                    {mapType === "roadmap" ? Satelite() : RoadMap()}
                  </button>
                </Tooltip>
                <Tooltip title="Recenter">
                  <button
                    type="button"
                    onClick={ReCenterToEurope}
                    style={{
                      borderRadius: "50%",
                      width: "45px",
                      height: "45px",
                      marginLeft: "5px",
                      backgroundColor: "#fff",
                    }}
                  >
                    {MapRecenter()}
                  </button>
                </Tooltip>
              </div>
              {/* POIs Designing Div */}
              <div
                className={`position-absolute top-0 start-0 bg-none p-4 d-block`}
                style={{
                  width: "325px",
                  height: "50vh",
                  marginTop: "50px",
                }}
              >
                <div className="row bg-white">
                  <>
                    <div className="mb-3">
                      <div style={{ textAlign: "center" }}>
                        <b>
                          <label
                            style={{ fontSize: "18px", marginBottom: "0" }}
                            className="form-label"
                          >
                            {pOIsMarkerPosition?.poisName !== ""
                              ? pOIsMarkerPosition?.poisName
                              : "POI Name"}
                          </label>
                        </b>
                      </div>
                      <label
                        htmlFor=""
                        className="form-label"
                        style={{ marginBottom: "2px", fontSize: "15px" }}
                      >
                        Lat:
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="Lat"
                        placeholder="37.7749"
                        style={{ padding: "3px 10px" }}
                        value={pOIsMarkerPosition?.lat ?? 0}
                        onChange={(e) =>
                          setPOIsMarkerPosition((prev) => ({
                            ...prev,
                            lat: parseFloat(e.target.value),
                          }))
                        }
                      />
                      <label
                        htmlFor=""
                        className="form-label"
                        style={{ marginBottom: "2px", fontSize: "15px" }}
                      >
                        Lng:
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        style={{ padding: "3px 10px" }}
                        id="Lng"
                        placeholder="-122.4194"
                        value={pOIsMarkerPosition?.lng ?? 0}
                        onChange={(e) =>
                          setPOIsMarkerPosition((prev) => ({
                            ...prev,
                            lng: parseFloat(e.target.value),
                          }))
                        }
                      />
                      <label
                        htmlFor=""
                        className="form-label"
                        style={{ marginBottom: "2px", fontSize: "15px" }}
                      >
                        Pois Type:
                      </label>
                      <MultiselectDropdown
                        styles={{
                          searchBox: {
                            border: "1px solid #ced4da",
                            borderRadius: "5px",
                            width: "100%",
                            padding: "1px 5px",
                          },
                          chips: {
                            padding: "1px",
                          },
                          multiselectContainer: {
                            padding: "1px",
                          },
                          option: {
                            padding: "3px 10px",
                          },
                        }}
                        options={poisTypes}
                        selectedvals={selectedPoisType}
                        setSelectedVals={setSelectedPoisType}
                        isSingleSelect={true}
                        placeholder={"Select Pois Type"}
                        id={"PoisType"}
                      />
                      {selectedPoisType?.[0] && (
                        <>
                          {selectedPoisType?.[0]?.key === "Joker" && (
                            <>
                              <label
                                htmlFor=""
                                className="form-label"
                                style={{
                                  marginBottom: "2px",
                                  fontSize: "15px",
                                }}
                              >
                                Joker Type:
                              </label>
                              <MultiselectDropdown
                                styles={{
                                  searchBox: {
                                    border: "1px solid #ced4da",
                                    borderRadius: "5px",
                                    width: "100%",
                                    padding: "1px 5px",
                                  },
                                  chips: {
                                    padding: "1px",
                                  },
                                  multiselectContainer: {
                                    padding: "1px",
                                  },
                                  option: {
                                    padding: "3px 10px",
                                  },
                                }}
                                options={jokerTypes}
                                selectedvals={selectedJokerType}
                                setSelectedVals={setSelectedJokerType}
                                isSingleSelect={true}
                                placeholder={"Select Joker Type"}
                                id={"JokerType"}
                              />
                            </>
                          )}
                          {selectedPoisType?.[0]?.key === "Snelheid" && (
                            <>
                              <label
                                htmlFor="SnelheidSpeedLimit"
                                className="form-label"
                                style={{
                                  marginBottom: "2px",
                                  fontSize: "15px",
                                }}
                              >
                                Snelheid Speed Limit (km/h):
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                style={{ padding: "3px 10px" }}
                                id="SnelheidSpeedLimit"
                                placeholder="90 km/h"
                                value={pOIsMarkerPosition?.speedLimit ?? 0}
                                onChange={(e) =>
                                  setPOIsMarkerPosition((prev) => ({
                                    ...prev,
                                    speedLimit: parseInt(e.target.value),
                                  }))
                                }
                              />
                            </>
                          )}
                          {selectedPoisType?.[0]?.key !== "Finish" &&
                            selectedPoisType?.[0]?.key !== "Joker" &&
                            selectedPoisType?.[0]?.key !== "Snelheid" && (
                              <>
                                <label
                                  htmlFor=""
                                  className="form-label"
                                  style={{
                                    marginBottom: "2px",
                                    fontSize: "15px",
                                  }}
                                >
                                  Points:
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  style={{ padding: "3px 10px" }}
                                  id="Points"
                                  placeholder="100"
                                  value={pOIsMarkerPosition?.points ?? ""}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    // Allow empty input, a single "-", or valid numbers (including negative)
                                    const isValid = /^-?\d*$/.test(value);

                                    if (isValid) {
                                      setPOIsMarkerPosition((prev) => ({
                                        ...prev,
                                        points:
                                          value === "" || value === "-"
                                            ? value
                                            : parseInt(value),
                                      }));
                                    }
                                  }}
                                />
                              </>
                            )}
                          <label
                            htmlFor=""
                            className="form-label"
                            style={{ marginBottom: "2px", fontSize: "15px" }}
                          >
                            Extra Info:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            style={{ padding: "3px 10px" }}
                            id="ExtraInfo"
                            placeholder="1 2025"
                            value={pOIsMarkerPosition?.extraInfo ?? ""}
                            onChange={(e) =>
                              setPOIsMarkerPosition((prev) => ({
                                ...prev,
                                extraInfo: e.target.value,
                              }))
                            }
                          />
                        </>
                      )}

                      <label
                        htmlFor=""
                        className="form-label"
                        style={{ marginBottom: "2px", fontSize: "15px" }}
                      >
                        Marker Radius:
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        style={{ padding: "3px 10px" }}
                        id="Marker Radius"
                        placeholder="100"
                        value={pOIsMarkerPosition?.radius ?? 0}
                        onChange={(e) => {
                          const value = e.target.value;
                          console.log("radius", value);
                          setPOIsMarkerPosition((prev) => ({
                            ...prev,
                            radius: parseInt(value),
                          }));
                        }}
                      />
                      <Tooltip title="Max Zoom to View Nearby Area For Plotting POIs">
                        <button
                          type="button"
                          onClick={() => MaxZoomToPlottedPOIs()}
                          style={{
                            borderRadius: "5%",
                            height: "35px",
                            width: "100%",
                            backgroundColor: "#fff",
                            marginTop: "5px",
                            fontSize: "15px",
                          }}
                        >
                          {"View with Full Zoom"} {FocusIcon()}
                        </button>
                      </Tooltip>
                      <Tooltip title="Save POIs In Database">
                        <button
                          type="button"
                          onClick={SavePOI}
                          style={{
                            borderRadius: "5%",
                            height: "35px",
                            width: "100%",
                            backgroundColor: "#2c786c",
                            color: "#fff",
                            marginTop: "5px",
                            fontSize: "15px",
                          }}
                        >
                          {"Save POIs"}
                        </button>
                      </Tooltip>
                    </div>
                  </>
                </div>
              </div>
              {/* POIs Grid */}
              <div
                className={`position-absolute top-0 end-0 bg-none p-4 d-block`}
                style={{
                  width: "400px",
                  height: "50vh",
                  marginTop: "50px",
                }}
              >
                <div
                  className="row bg-white"
                  style={{ maxHeight: "550px", overflowY: "auto" }}
                >
                  <div>
                    <table className="table">
                      <tbody>
                        {savedPOIs?.map((pois, index) => (
                          <tr key={index}>
                            <td>
                              <TrimmableText text={pois.Name} />
                              <br />
                              <span style={{ fontSize: "12px" }}>
                                {pois.Lat}, {pois.Lng}
                              </span>
                            </td>
                            <td style={{ verticalAlign: "middle" }}>
                              <Tooltip title="Max Zoom to View Nearby Area For Plotting POIs">
                                <button
                                  onClick={() =>
                                    MaxZoomToPlottedPOIs(pois.Lat, pois.Lng)
                                  }
                                  style={{
                                    border: "1px solid #007BFF",
                                    backgroundColor: "#007BFF",
                                    borderRadius: "5px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {FocusIcon("15px", "white")}
                                </button>
                              </Tooltip>
                              <button
                                onClick={() =>
                                  pois.Id === activePOIsEditId
                                    ? cancelBtnHandler()
                                    : editBtnHandler(pois)
                                }
                                style={{
                                  border:
                                    pois.Id === activePOIsEditId
                                      ? "1px solid black"
                                      : "1px solid #2c786c",
                                  backgroundColor:
                                    pois.Id === activePOIsEditId
                                      ? "#fff"
                                      : "#2c786c",
                                  borderRadius: "5px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  marginLeft: "5px",
                                }}
                              >
                                {pois.Id === activePOIsEditId
                                  ? CrossIcon("15px")
                                  : DrawIcon("15px", "#fff")}
                              </button>
                              <button
                                onClick={() => deleteBtnHandler(pois.Id)}
                                style={{
                                  border: "1px solid #dc3545",
                                  backgroundColor: "#dc3545",
                                  borderRadius: "5px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  marginLeft: "5px",
                                }}
                              >
                                {TrashIcon("15px", "white")}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <LoginPage setAccessToken={setAccessToken} />
      )}
    </>
  );
}
